import { render, staticRenderFns } from "./AppRate.vue?vue&type=template&id=547ef38b"
import script from "./AppRate.vue?vue&type=script&lang=js"
export * from "./AppRate.vue?vue&type=script&lang=js"
import style0 from "./AppRate.vue?vue&type=style&index=0&id=547ef38b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports